import InboundSingle from "./InboundSingle";

export default function Inbound({ inbound, setInbound, isRefund = false }) {

    return (

        <div className="flex flex-col gap-2">
            {
                inbound && inbound.map((single, index) => {
                    return <InboundSingle item={single} index={index} key={index} setInbound={setInbound} isRefund={isRefund} />
                })
            }
        </div>

    )
}
